import InstallerShelfCard from './InstallerShelfCard';
import InstallerStepCard from './InstallerStepCard';
import InstallerHangerCard from './InstallerHangerCard';
import StoresColumn from './StoresColumn';

export default function StoresSensors(props) {

    const { selectedClient, selectedSite, selectedEdge } = props;

    return (
        <StoresColumn color="#fdd54650">
            <InstallerShelfCard
                edgeId={selectedEdge._id}
                siteId={selectedSite._id}
                clientId={selectedClient._id}
            />

            {selectedSite.siteType !== "Inventory" && (
                <InstallerStepCard
                    edgeId={selectedEdge._id}
                    siteId={selectedSite._id}
                    clientId={selectedClient._id}
                    edge={selectedEdge}
                />
            )}

            {selectedSite.siteType !== "Inventory" && (
                <InstallerHangerCard
                    edgeId={selectedEdge._id}
                    siteId={selectedSite._id}
                    clientId={selectedClient._id}
                />
            )}
        </StoresColumn>
    )
}
